import Popover from "@mui/material/Popover/index.js";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography/index.js";
const ActionsPopover = styled(Popover)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "6px"
  }
}));
const ActionMenuListItemText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
export {
  ActionMenuListItemText,
  ActionsPopover
};
